<div class="almost-there-grid" [ngClass]="authService.user !== null && !authService.user['confirmed'] ? 'tw-pt-14 md:tw-pt-16 lg:tw-pt-14' : ''">
  <div class="left-pane">
    <div class="illustration-outer">
      <img class="illustration" src="assets/images/undraw_fill-forms_npwp.svg" alt="Fill Forms Illustration" width="480" height="314" />
    </div>
  </div>
  <div class="right-pane">
    <div class="form-outer">
      <h1 class="header">Almost there!</h1>
      <nb-card class="login-container">
        <nb-card-body>
          <form [formGroup]="form" (ngSubmit)="createWorkspace()" class="tw-overflow-hidden">
            <fullname class="tw-w-full" label="Your full name" [control]="form.controls.full_name" [showIcon]="true" [required]="true" id="full_name" [autofocus]="true"></fullname>
            <phone-input class="tw-w-full" [countries]="countries" [control]="form.controls.phone" [required]="true" id="phone_number"></phone-input>
            <basic-input [control]="form.controls.name" label="Your organization name" [icon]="orgIcon" iconType="stroke" [required]="true"></basic-input>
            @if (!isUserEmailBusiness) {
              <email-input [control]="form.controls.business_email" label="Your business email" [icon]="businessEmailIcon" iconType="fill" [required]="true"></email-input>
            }
            <slug [control]="form.controls.slug" [required]="true" label=" Organization acronym (URL, Slug)"></slug>
            <country-select [control]="form.controls.country" [countries]="countries" label="Country of organization" [required]="true"></country-select>
            <button
              type="submit"
              [buttonSpinner]="form.pending"
              class="tw-h-10 tw-my-2 tw-bg-blue-600 tw-text-sm tw-text-white tw-rounded-md tw-px-4 tw-py-2 tw-w-full"
            >
              Create organization
            </button>
          </form>
        </nb-card-body>
      </nb-card>
    </div>
  </div>
</div>
